import { useEffect, useState } from 'react';

/**
 * Returns a value that updates `delayMs` after the input value last changed.
 * Useful for debouncing search inputs feeding queries. The initial value
 * passes through immediately; only subsequent changes are delayed.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
